// require jQuery normally
const $ = require('jquery');

// create global $ and jQuery variables
global.$ = global.jQuery = $;

var snapEngageData = {ticket: '' , customerNumber: '', userName: ''};
window.snapEngageData = snapEngageData;
